__turbopack_context__.v({
  "center": "LayoutCenter-module__7tuwMq__center",
  "centerIntrinsic": "LayoutCenter-module__7tuwMq__centerIntrinsic",
  "container": "LayoutCenter-module__7tuwMq__container",
  "flex": "LayoutCenter-module__7tuwMq__flex",
});
